module.exports = __webpack_public_path__ + "static/media/diamond_512.3a6a13b7.png";